import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { collectionsheet, datewisegroup, downloadcollection, grouplist, liststaff, pendingcollection, reportsummary, reporttopcollection } from '../../../services/admin';
import { toast } from 'react-toastify';
import exportUrl from '../../../exportUrl';
import { deliverReport } from '../../../utils/printPdf';
import { useLocation } from 'react-router-dom';
import { branchlist } from '../../../services/master';
import Select from "react-select";

export const CollectionSheet = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [glist, setGlist] = useState([]);
    const [mgrpid, setMGrpId] = useState("");
    const [grpid, setGrpId] = useState("");
    const [staffid, setGStaff] = useState("");
    const [gcenter, setGCenter] = useState("");
    const [fdate, setFDate] = useState("");
    const [tdate, setTDate] = useState("");
    const [urllink, setUrllink] = useState("");
    const [slist, setSlist] = useState([]);

    const location = useLocation();
    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        setFDate(moment(new Date()).format("YYYY-MM-DD"));
        setTDate(moment(new Date()).format("YYYY-MM-DD"));
        setGrpId("");
        setMGrpId("");
        setFilterProduct([]);
        setGCenter("");
        setGStaff("");

        if (path === "summary" || path === "pendingcollectionsheet" || path === "staffwisecollection") {
            liststaff(localStorage.getItem("branch")).then((res) => {
                if (res.status === true) {
                    setSlist(res.data.details);
                }
            });
            if (path === "summary") {
                funlist('', moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), path, "");

            }
        } else if (path === "collectionsheet" || path === "dailycollectionsheet" || path === "preloanreport") {
            
            const temp = new FormData();
            temp.append("branch_id", localStorage.getItem("branch"));
            grouplist(temp).then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].group_name
                            })
                        }
                        setGlist(arr);
                    }
                }
            });
            funlist('', moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), path, "");

        } else if (path === "topcollectionsheet") {
            branchlist().then((res) => {
                if (res.status === true) {
                    const userBranches = localStorage.getItem("branch")
                    const filteredBranches = res.data.filter(branch => userBranches.includes(branch.id));
                    setSlist(filteredBranches);
                    // setSlist(res.data);
                }
            });
        }

    }, [location.pathname]);

    const columnDefs = [

        {
            headerName: "Collection Date",
            field: "loan_duedate",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Paid Date",
            field: "loan_paiddate",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null && params.value !== "") {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Staff",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Member",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan Amount",
            field: "loan1_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan EMI",
            field: "loan1_emi",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Turn",
            field: "loan1_turn",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Ins",
            field: "loan1_ins",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Addon Amount",
            field: "loan2_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan EMI",
            field: "loan2_emi",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Turn",
            field: "loan2_turn",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Ins",
            field: "loan2_ins",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Loan OD",
            field: "loan1_od",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return parseInt(params.data.loan1_od) + parseInt(params.data.loan2_od);
                }
            }
        },
        {
            headerName: "Collection",
            field: "loan_collection",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            // cellRenderer: function (params) {
            //     const loan1Emi = parseInt(params.data.loan1_emi )|| 0; 
            //     const loan2Emi = parseInt(params.data.loan2_emi) || 0;
            //     const loanod = parseInt(params.data.loan_od) || 0;

            //     const totalEmi = loan1Emi + loan2Emi + loanod;
            //     return totalEmi;
            // }
        },
        {
            headerName: "Remarks",
            field: "loan_remarks",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];
    const columnPDefs = [

        {
            headerName: "Collection Date",
            field: "collection_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Group Name",
            field: "loan_group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Member",
            field: "loan_member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan Amount",
            field: "loan1_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan EMI",
            field: "loan1_emi",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Turn",
            field: "loan1_turn",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Ins",
            field: "loan1_ins",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pending Week",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pending EMI",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan Amount",
            field: "loan2_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan EMI",
            field: "loan2_emi",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Turn",
            field: "loan2_turn",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Ins",
            field: "loan2_ins",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pending Week",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pending EMI",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Collection",
            field: "total_collection",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Remarks",
            field: "remarks",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    const columnSDefs = [
        {
            headerName: "Group Name",
            field: "loan_group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff",
            field: "loan_staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Member",
            field: "total_members",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan To Members",
            field: "total_principle",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Interest on Loan Members",
            field: "total_interest",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total",
            field: "total",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];

    const columnTCDefs = [
        {
            headerName: "Collection Date",
            field: "collection_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Group Name",
            field: "total_groups",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Member",
            field: "total_members",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Amount",
            field: "total_collection",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff Signature",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "BM Signature",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Remarks",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];

    function handlegroup(e) {
        setGrpId(e.target.value);
        setGCenter("");
        funlist(e.target.value, fdate, tdate, urllink, mgrpid);
        if (glist.length > 0) {
            glist.map((item) => {
                if (item.value == e.target.value) {
                    setGStaff(item.staff_name);
                    setGCenter(item.group_name);
                }
            })
        }
    }

    function handlegrouplist(e) {
        if (e !== null) {
            setMGrpId(e);
            funlist(grpid, fdate, tdate, urllink, e);

            // setGrpId(e.value);
        } else {
            setMGrpId("");
            funlist(grpid, fdate, tdate, urllink, "");

            // setGrpId("");

        }

    }

    function handlestaff(e) {
        setGrpId(e.target.value);
        if (urllink === "topcollectionsheet") {
            if (slist.length > 0) {
                slist.map((item) => {
                    if (item.id == e.target.value) {
                        setGStaff(item.branch_name);
                    }
                })
            }
        } else {
            if (slist.length > 0) {
                slist.map((item) => {
                    if (item.id == e.target.value) {
                        setGStaff(item.staff_name);
                    }
                })
            }
        }

        funlist(e.target.value, fdate, tdate, urllink, mgrpid);
    }

    function funlist(fid, ldate, gdate, gtype, mgid) {
        if (new Date(gdate) < new Date(ldate)) {
            gdate = "";
        }
        setFDate(ldate);
        setTDate(gdate);
        setFilterProduct([]);
        if (gtype === "dailycollectionsheet") {
            // fid !== "" && 
            if (ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("group_id", fid);
                temp.append("from_date", ldate);
                temp.append("to_date", gdate);
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("group", mgid ? mgid.value : "");
                collectionsheet(temp).then((res) => {
                    if (res.status === true) {
                        setFilterProduct(res.data);
                    }
                });
            }
        } else if (gtype === "collectionsheet") {
            // fid !== "" && 
            
            if (ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("group_id", fid);
                temp.append("from_date", ldate);
                temp.append("to_date", gdate);
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("group", mgid ? mgid.value : "");


                // datewisegroup(temp).then((res) => {
                //     if (res.status === true) {
                //         console.log(res.data);
                //     }
                // })
                collectionsheet(temp).then((res) => {
                    if (res.status === true) {
                        setFilterProduct(res.data);
                    }
                });


            }
        } else if (gtype === "staffwisecollection") {

            if (fid !== "" && ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("group_id", fid);
                temp.append("from_date", ldate);
                temp.append("to_date", gdate);
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("group", mgid ? mgid.value : "");
                collectionsheet(temp).then((res) => {
                    if (res.status === true) {
                        setFilterProduct(res.data);
                    }
                });
            }
        } else if (gtype === "summary") {
            // fid !== "" && 
            if (ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("branch_id", localStorage.getItem("branch"));
                temp.append("from_date", ldate);
                temp.append("to_date", gdate);
                reportsummary(temp).then((res) => {
                    if (res.status === true) {
                        setFilterProduct(res.data);
                    }
                })

            }

        } else if (gtype === "topcollectionsheet") {
            if (fid !== "" && ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("branch", fid);
                temp.append("from_date", ldate);
                temp.append("to_date", gdate);
                reporttopcollection(temp).then((res) => {
                    if (res.status === true) {
                        setFilterProduct(res.data);
                    }
                })


            }
        } else if (gtype === "pendingcollectionsheet") {
            if (fid !== "" && ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("group_id", fid);
                // temp.append("from_date", ldate);
                // temp.append("to_date", gdate);
                pendingcollection(temp).then((res) => {
                    if (res.status === true) {
                        setFilterProduct(res.data);
                    }
                })


            }
        }else if (gtype === "preloanreport") {
            // fid !== "" && 
            if (ldate !== "" && gdate !== "") {
                const temp = new FormData();
                temp.append("group_id", fid);
                temp.append("from_date", ldate);
                temp.append("to_date", gdate);
                temp.append("branch", localStorage.getItem("branch"));
                temp.append("group", mgid ? mgid.value : "");
                collectionsheet(temp).then((res) => {
                    if (res.status === true) {
                        const sdata =res.data.filter((item) => {
                            return item.payment_type == "advanced"
                        })
                        setFilterProduct(sdata);
                    }
                });
            }
        } 

    }

    function downloadfile(fid, ldate, gdate, dtype, grid) {
        if (filterProduct.length > 0) {
            let gid = "";
            if (grid) {
                gid = grid.value
            }
            if (urllink === "dailycollectionsheet") {
                // fid !== "" && 
                if (ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/weekdownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&center_name=' + gcenter + '&staff_name=' + staffid + '&type=' + dtype + '&format=daily&branch=' + localStorage.getItem("branch") + "&group=" + gid, dtype);
                    // window.open(exportUrl + 'report/download?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&center_name=' + gcenter + '&staff_name=' + staffid + '&type=' + dtype, "_blank");
                } else {
                    toast.error("Please Select Date");
                }
            } else if (urllink === "collectionsheet") {
                // fid !== "" && 
                if (ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/weekdownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&center_name=' + gcenter + '&staff_name=' + staffid + '&type=' + dtype + '&format=weekly&branch=' + localStorage.getItem("branch") + "&group=" + gid, dtype);
                } else {
                    toast.error("Please Select Date");
                }
            } else if (urllink === "staffwisecollection") {
                // 
                if (fid !== "" && ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/weekdownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&center_name=' + gcenter + '&staff_name=' + staffid + '&type=' + dtype + '&format=staffwise&branch=' + localStorage.getItem("branch") + "&group=" + gid, dtype);
                } else {
                    toast.error("Please Select Staff");
                }
            } else if (urllink === "summary") {
                // fid !== "" && 
                if (ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/summarydownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&staff_name=' + staffid + '&type=' + dtype + '&branch_id=' + localStorage.getItem("branch"), dtype);
                } else {
                    toast.error("Please Select Date");
                }
            } else if (urllink === "topcollectionsheet") {
                if (fid !== "" && ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/topcollectiondownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&staff_name=' + staffid + '&type=' + dtype+ '&branch=' + localStorage.getItem("branch"), dtype);
                } else {
                    toast.error("Please Select Group");
                }
            } else if (urllink === "pendingcollectionsheet") {
                if (fid !== "" && ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/pendingcollectiondownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&staff_name=' + staffid + '&type=' + dtype, dtype);
                } else {
                    toast.error("Please Select Staff");
                }
            }else if (urllink === "preloanreport") {
                // fid !== "" && 
                if (ldate !== "" && gdate !== "") {
                    deliverReport(exportUrl + 'report/preloandownload?group_id=' + fid + '&from_date=' + ldate + '&to_date=' + gdate + '&center_name=' + gcenter + '&staff_name=' + staffid + '&type=' + dtype + '&format=weekly&branch=' + localStorage.getItem("branch") + "&group=" + gid, dtype);
                } else {
                    toast.error("Please Select Date");
                }
            } 
        }



    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">{urllink === "summary" ? "Summary Report" : urllink === "topcollectionsheet" ? "Top Collection Sheet" : urllink === "collectionsheet" ? "Weekly Collection Sheet" : urllink === "pendingcollectionsheet" ? "Pending Collection Sheet" : urllink === "staffwisecollection" ? "Staffwise Collection Sheet" : urllink === "preloanreport" ? "Pre Loan Report" : "Daily Collection Sheet"}
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {urllink === "summary" ? "Summary Report" : urllink === "topcollectionsheet" ? "Top Collection Sheet" : urllink === "collectionsheet" ? "Weekly Collection Sheet" : urllink === "pendingcollectionsheet" ? "Pending Collection Sheet" : urllink === "staffwisecollection" ? "Staffwise Collection Sheet" : urllink === "preloanreport" ? "Pre Loan Report" : "Daily Collection Sheet"}
                    </li>
                </ol>

            </div>


            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    {urllink === "summary" ? "Summary Report" : urllink === "topcollectionsheet" ? "Top Collection Sheet" : urllink === "collectionsheet" ? "Weekly Collection Sheet" : urllink === "pendingcollectionsheet" ? "Pending Collection Sheet" : urllink === "staffwisecollection" ? "Staffwise Collection Sheet" : urllink === "preloanreport" ? "Pre Loan Report" :"Daily Collection Sheet"}</h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {urllink === "staffwisecollection" &&
                                        <>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Staff<span className="text-danger"> *</span>
                                                    </label>
                                                    <select className="default-select form-control wide" onChange={handlestaff} value={grpid}>
                                                        <option value="" disabled>Select Staff</option>
                                                        {slist.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.id}>
                                                                    {item.staff_name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        From Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={fdate}
                                                        onChange={(e) => funlist(grpid, e.target.value, tdate, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        To Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        min={fdate}
                                                        value={tdate}
                                                        onChange={(e) => funlist(grpid, fdate, e.target.value, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-12 col-sm-6 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>

                                                </div>

                                            </div>
                                        </>
                                    }
                                    {
                                        urllink === "collectionsheet" &&
                                        <>
                                           
                                            {/*   <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Center
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={gcenter}
                                                        onChange={(e) => setGCenter(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Staff
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={staffid}
                                                        onChange={(e) => setGStaff(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>*/}
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        From Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={fdate}
                                                        onChange={(e) => funlist(grpid, e.target.value, tdate, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        To Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        min={fdate}
                                                        value={tdate}
                                                        onChange={(e) => funlist(grpid, fdate, e.target.value, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                             <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Group<span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Select Group"
                                                        value={mgrpid}
                                                        options={glist}
                                                        onChange={handlegrouplist}
                                                        isSearchable={true}
                                                        isClearable
                                                        hidden
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-12 col-sm-6 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {
                                        urllink === "dailycollectionsheet" &&
                                        <>
                                            {/*       <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Group<span className="text-danger"> *</span>
                                                    </label>
                                                    <select className="default-select form-control wide" onChange={handlegroup} value={grpid}>
                                                        <option value="" disabled>Select Group</option>
                                                        {glist.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.id}>
                                                                    {item.group_name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div> 
                                            <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Center
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={gcenter}
                                                        onChange={(e) => setGCenter(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Staff
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={staffid}
                                                        onChange={(e) => setGStaff(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>*/}
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Collection Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={fdate}
                                                        onChange={(e) => funlist(grpid, e.target.value, e.target.value, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-xl-8 col-sm-6 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {urllink === "summary" &&
                                        <>
                                            {/* <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Staff<span className="text-danger"> *</span>
                                                    </label>
                                                    <select className="default-select form-control wide" onChange={handlestaff} value={grpid}>
                                                        <option value="" disabled>Select Staff</option>
                                                        {slist.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.id}>
                                                                    {item.staff_name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div> */}
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        From Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={fdate}
                                                        onChange={(e) => funlist(grpid, e.target.value, tdate, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        To Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        min={fdate}
                                                        value={tdate}
                                                        onChange={(e) => funlist(grpid, fdate, e.target.value, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>

                                                </div>

                                            </div>
                                        </>
                                    }
                                    {urllink === "pendingcollectionsheet" &&
                                        <>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Staff<span className="text-danger"> *</span>
                                                    </label>
                                                    <select className="default-select form-control wide" onChange={handlestaff} value={grpid}>
                                                        <option value="" disabled>Select Staff</option>
                                                        {slist.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.id}>
                                                                    {item.staff_name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-xl-8 col-sm-2 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>

                                                </div>

                                            </div>
                                        </>
                                    }

                                    {urllink === "topcollectionsheet" &&
                                        <>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Branch<span className="text-danger"> *</span>
                                                    </label>
                                                    <select className="default-select form-control wide" onChange={handlestaff} value={grpid}>
                                                        <option value="" disabled>Select Branch</option>
                                                        {slist.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.id}>
                                                                    {item.branch_name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        From Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={fdate}
                                                        onChange={(e) => funlist(grpid, e.target.value, tdate, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        To Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        min={fdate}
                                                        value={tdate}
                                                        onChange={(e) => funlist(grpid, fdate, e.target.value, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-12 col-sm-12 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>

                                                </div>

                                            </div>
                                        </>
                                    }
{
                                        urllink === "preloanreport" &&
                                        <>
                                           
                                            {/*   <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Center
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={gcenter}
                                                        onChange={(e) => setGCenter(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-4">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Staff
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={staffid}
                                                        onChange={(e) => setGStaff(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>*/}
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        From Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        value={fdate}
                                                        onChange={(e) => funlist(grpid, e.target.value, tdate, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        To Date
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        min={fdate}
                                                        value={tdate}
                                                        onChange={(e) => funlist(grpid, fdate, e.target.value, urllink, mgrpid)}
                                                    />
                                                </div>
                                            </div>
                                             <div className="col-xl-4 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Group<span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Select Group"
                                                        value={mgrpid}
                                                        options={glist}
                                                        onChange={handlegrouplist}
                                                        isSearchable={true}
                                                        isClearable
                                                        hidden
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-12 col-sm-6 mt-4">
                                                <div className='text-end'>
                                                    <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'pdf', mgrpid)}>Download PDF</a>
                                                    <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, fdate, tdate, 'excel', mgrpid)}>Download Excel</a>
                                                    <a className="btn btn-primary" onClick={() => downloadfile(grpid, fdate, tdate, 'print', mgrpid)}>Print</a>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                                {urllink !== "pendingcollectionsheet" &&
                                    <div className="ag-theme-alpine ag-style mt-2">
                                        {(urllink === "collectionsheet" || urllink === "dailycollectionsheet" || urllink === "staffwisecollection" || urllink === "preloanreport") &&
                                            <AgGridReact
                                                columnDefs={columnDefs}
                                                rowData={filterProduct}
                                                pagination="true"
                                                paginationPageSize="10"
                                                sortingOrder={["asc", "desc"]}
                                                suppressDragLeaveHidesColumns={true}
                                            />
                                        }
                                        {urllink === "summary" &&
                                            <AgGridReact
                                                columnDefs={columnSDefs}
                                                rowData={filterProduct}
                                                pagination="true"
                                                paginationPageSize="10"
                                                sortingOrder={["asc", "desc"]}
                                                suppressDragLeaveHidesColumns={true}
                                            />
                                        }
                                        {urllink === "topcollectionsheet" &&
                                            <AgGridReact
                                                columnDefs={columnTCDefs}
                                                rowData={filterProduct}
                                                pagination="true"
                                                paginationPageSize="10"
                                                sortingOrder={["asc", "desc"]}
                                                suppressDragLeaveHidesColumns={true}
                                            />
                                        }
                                        {/* {urllink === "pendingcollectionsheet" &&
     <AgGridReact
         columnDefs={columnPDefs}
         rowData={filterProduct}
         pagination="true"
         paginationPageSize="10"
         sortingOrder={["asc", "desc"]}
         suppressDragLeaveHidesColumns={true}
     />
 } */}

                                    </div>
                                }
                                {urllink === "pendingcollectionsheet" &&
                                    <div className='row mt-4'>
                                        {filterProduct.map((item, index) => {
                                            return (
                                                <div className='col-xl-12 col-sm-12' key={index}>
                                                    <h4>{item.loan_group_name}</h4>
                                                    <div className='table-container'>
                                                        <table className="responsive-table result-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Name</th>
                                                                    <th>Amount</th>
                                                                    <th>EMI</th>
                                                                    <th>Turn</th>
                                                                    <th>Ins</th>
                                                                    <th>Pending Week</th>
                                                                    <th>Pending Amount</th>
                                                                    <th>Amount</th>
                                                                    <th>EMI</th>
                                                                    <th>Turn</th>
                                                                    <th>Ins</th>
                                                                    <th>Pending Week</th>
                                                                    <th>Pending Amount</th>
                                                                    <th>Total</th>
                                                                    <th>Collection</th>
                                                                    <th>Sign</th>
                                                                    <th>Remarks</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {item.collections.map((entry, entryIndex) => (
                                                                    <tr key={entryIndex}>
                                                                        <td>{entryIndex + 1}</td>
                                                                        <td>{entry?.loan_member_name || 'N/A'}</td> {/* Safe access */}
                                                                        <td>{entry?.loan1_amount || 0}</td>
                                                                        <td>{entry?.loan1_emi || 0}</td>
                                                                        <td>{entry?.loan1_turn || 0}</td>
                                                                        <td>{entry?.loan1_ins || 0}</td>
                                                                        <td>{Math.max(parseInt(entry?.loan1_turn) - parseInt(entry?.loan1_ins) || 0, 0)}</td> {/* Ensure non-negative */}
                                                                        <td>{Math.max((parseInt(entry?.loan1_turn) - parseInt(entry?.loan1_ins)) * parseInt(entry?.loan1_emi) || 0, 0)}</td>
                                                                        <td>{entry?.loan2_amount || 0}</td>
                                                                        <td>{entry?.loan2_emi || 0}</td>
                                                                        <td>{entry?.loan2_turn || 0}</td>
                                                                        <td>{entry?.loan2_ins || 0}</td>
                                                                        <td>{Math.max(parseInt(entry?.loan2_turn) - parseInt(entry?.loan2_ins) || 0, 0)}</td> {/* Ensure non-negative */}
                                                                        <td>{Math.max((parseInt(entry?.loan2_turn) - parseInt(entry?.loan2_ins)) * parseInt(entry?.loan2_emi) || 0, 0)}</td>
                                                                        <td>
                                                                            {Math.max(
                                                                                (parseInt(entry?.loan1_turn) - parseInt(entry?.loan1_ins)) * parseInt(entry?.loan1_emi) || 0,
                                                                                0
                                                                            ) +
                                                                                Math.max(
                                                                                    (parseInt(entry?.loan2_turn) - parseInt(entry?.loan2_ins)) * parseInt(entry?.loan2_emi) || 0,
                                                                                    0
                                                                                )}
                                                                        </td>
                                                                        <td></td> {/* If not needed, remove */}
                                                                        <td></td> {/* Empty cell */}
                                                                        <td>{entry?.remarks || ''}</td> {/* Safe access */}
                                                                    </tr>
                                                                ))}
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>
                                            )
                                        })}

                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
